<template>
    <p style="display:none;">

			<icon-base icon-name="moon"><icon-moon /></icon-base>
		    <icon-base icon-name="AMF"><icon-AMF /></icon-base>
		    <icon-base icon-name="Subnet"><icon-Subnet /></icon-base>
		    <icon-base icon-name="HSS"><icon-HSS /></icon-base>
		    <icon-base icon-name="PCSCF"><icon-PCSCF /></icon-base>
		    <icon-base icon-name="UNMS"><icon-UNMS /></icon-base>
		    <icon-base icon-name="K8S"><icon-K8S /></icon-base>
		    <icon-base icon-name="K8SMaster"><icon-K8SMaster /></icon-base>
		    <icon-base icon-name="TopoBase" :width="58" :height="58" viewBox="0 0 58 58" ><icon-TopoBase  /></icon-base>
		    <icon-base icon-name="IconSCSCF"><icon-SCSCF /></icon-base> 
		    <icon-base icon-name="IconICSCF"><icon-ICSCF /></icon-base> 
		    <icon-base icon-name="IconVDOS"><icon-VDOS /></icon-base> 
		    <icon-base icon-name="IconGNB"><icon-GNB /></icon-base> 
		    <icon-base icon-name="IconNRF"><icon-NRF /></icon-base>
		    <icon-base icon-name="IconMRF"><icon-MRF /></icon-base>
		    <icon-base icon-name="IconMMTELAS"><icon-MMTELAS /></icon-base>
		    <icon-base icon-name="IconOAM_5GC"><icon-OAM5GC /></icon-base>
		    <icon-base icon-name="IconOAM_IMS"><icon-OAMIMS /></icon-base>

    </p>  
</template>

<script>
import IconBase from './IconBase.vue'

import IconMoon from './icons/IconMoon.vue'
import IconAMF from './icons/IconAMF.vue'
import IconSubnet from './icons/IconSubnet.vue'
import IconHSS from './icons/IconHSS.vue'
import IconPCSCF from './icons/IconPCSCF.vue'
import IconUNMS from './icons/IconUNMS.vue'
import IconK8S from './icons/IconK8S.vue'
import IconK8SMaster from './icons/IconK8SMaster.vue'
import IconTopoBase from './icons/IconTopoBase.vue'
import IconSCSCF from './icons/IconSCSCF.vue'
import IconICSCF from './icons/IconICSCF.vue'
import IconVDOS from './icons/IconVDOS.vue'
import IconGNB from './icons/IconGNB.vue'
import IconNRF from './icons/IconNRF.vue'
import IconMRF from './icons/IconMRF.vue'
import IconMMTELAS from './icons/IconMMTELAS.vue'
import IconOAM_5GC from './icons/IconOAM_5GC.vue'
import IconOAM_IMS from './icons/IconOAM_IMS.vue'

export default {
  components: {
    IconBase,
    IconMoon,
    IconAMF,   
    IconSubnet,
    IconHSS,
    IconPCSCF,
    IconUNMS,
    IconK8S,
    IconK8SMaster,
    IconTopoBase,
    IconSCSCF,
    IconICSCF,
    IconVDOS,
    IconGNB,
    IconNRF,
    IconMRF,
    IconMMTELAS,
    IconOAM_5GC,
    IconOAM_IMS,
  }
}
</script>

